import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql } from "gatsby"

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 1
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};

const Container = styled.div`
  color: #ffffff;
  width: 100%;

  .item-slider {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #9E9E9E;
    text-align: center;

    a {
      display: block;
      width: 100%;
      height: 100%;
    }

    .mobileImage,
    .desktopImage {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      display: block;
    }

    .desktopImage {
      display: none;
    }
  }

  @media (min-width: 767px) {
    .item-slider {
      .desktopImage {
        display: block;
      }
      .mobileImage {
        display: none;
      }
    }
  }
`;

export default function Banner() {
  const result = useStaticQuery(graphql`
    {
      central: prismicCentralDeBanners(lang: { eq: "pt-br" }) {
        data {
          meu_ambiente_home_principal {
            nome
            imagem_mobile {
              url
            }
            imagem_desktop {
              url
            }
            link {
              url
            }
            ordem
            ativo
          }
        }
      }
      allPrismicBannerHomeMeuAmbients {
        edges {
          node {
            data {
              imagem_mobile {
                url
              }
              imagem_desktop {
                url
              }
              link {
                url
              }
            }
          }
        }
      }
    }
  `)
  
  const { central, allPrismicBannerHomeMeuAmbients } = result
  const centralizedBanners = central && central.data
    ? (central.data.meu_ambiente_home_principal || [])
        .filter(({ ativo, imagem_desktop }) => ativo !== false && imagem_desktop && imagem_desktop.url)
        .sort((first, second) => (first.ordem || 0) - (second.ordem || 0))
    : []
  const legacyBanners = allPrismicBannerHomeMeuAmbients.edges.map(({ node }) => node.data)
  const banners = centralizedBanners.length ? centralizedBanners : legacyBanners

  return (
    <Container>
      <Carousel
        responsive={responsive}
        showDots={true}
        arrows={false}
        draggable={true}
      >
        {banners.map((banner, index) => {
          return (
            <div className="item-slider" key={index}>
              <a href={ banner.link ? banner.link.url : '' } target="_blank" rel="noreferrer">
                <img
                  className="desktopImage"
                  src={banner.imagem_desktop && banner.imagem_desktop.url}
                  alt={banner.nome || ''}
                />
                <img
                  className="mobileImage"
                  src={banner.imagem_mobile && banner.imagem_mobile.url}
                  alt={banner.nome || ''}
                />
              </a>
            </div>
          )
        })}
      </Carousel>
    </Container>
  )
}
